import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    // Default to 'light', or check localStorage
    const [theme, setTheme] = useState(() => {
        if (typeof window !== 'undefined') {
            const savedTheme = localStorage.getItem('theme');
            if (savedTheme) {
                return savedTheme;
            }
            // Optional: Check system preference
            // if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
            //     return 'dark';
            // }
        }
        return 'light';
    });

    useEffect(() => {
        const root = window.document.documentElement;
        const body = window.document.body;
        
        console.log('DEBUG: Switching theme to:', theme);
        
        // Remove both classes first
        root.classList.remove('light', 'dark');
        body.classList.remove('light', 'dark');
        
        // Add the current theme class
        root.classList.add(theme);
        body.classList.add(theme);

        // Also set data-theme attribute for CSS selectors
        root.setAttribute('data-theme', theme);
        body.setAttribute('data-theme', theme);

        // Save to localStorage
        localStorage.setItem('theme', theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
    };

    const value = {
        theme,
        toggleTheme,
        setTheme // Allow setting specific theme if needed
    };

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
